var _line, _line2, _line3, _line4, _path, _line5, _line6, _path2, _path3, _circle, _mask, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 318 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30.5,
    y1: 112.5,
    x2: 30.5,
    y2: 157.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 59.5,
    y1: 112.5,
    x2: 59.5,
    y2: 157.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 88.5,
    y1: 112.5,
    x2: 88.5,
    y2: 157.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 118.5,
    y1: 112.5,
    x2: 118.5,
    y2: 157.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 113V157",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 179.5,
    y1: 111.5,
    x2: 179.5,
    y2: 156.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 211.5,
    y1: 112.5,
    x2: 211.5,
    y2: 157.5,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 109V152C3 156.418 6.58173 160 11 160H141.346H210.519H245.5",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 110H213.139H142.759H72.3796H37.1898H19.5949H10.7975H6.39873V110C4.38217 110 3.07403 107.874 3.9832 106.074L5.37792 103.312L8.75585 96.625L15.5117 83.25L29.0234 56.5L54.3825 6.29485C55.4032 4.27417 57.4743 3 59.7381 3H226.931C229.214 3 231.3 4.29566 232.311 6.34253L257.089 56.5L263.696 69.875L267.5 78",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 123,
    r: 44.5,
    stroke: "#808080",
    strokeWidth: 5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 130.333C290 140.643 281.941 149 272 149C262.059 149 254 140.643 254 130.333C254 123.176 262.675 107.964 267.98 99.3301C269.849 96.2887 274.151 96.2887 276.02 99.3301C281.325 107.964 290 123.176 290 130.333Z",
    stroke: "#808080"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.02 99.3301L271.76 101.948V101.948L276.02 99.3301ZM285 130.333C285 138.054 279.01 144 272 144V154C284.872 154 295 143.231 295 130.333H285ZM272 144C264.99 144 259 138.054 259 130.333H249C249 143.231 259.128 154 272 154V144ZM259 130.333C259 129.393 259.32 127.736 260.159 125.332C260.966 123.021 262.124 120.374 263.49 117.586C266.221 112.015 269.623 106.207 272.24 101.948L263.72 96.7125C261.032 101.087 257.444 107.202 254.511 113.185C253.046 116.174 251.703 119.212 250.718 122.036C249.765 124.767 249 127.695 249 130.333H259ZM271.76 101.948C274.377 106.207 277.779 112.015 280.51 117.586C281.876 120.374 283.034 123.021 283.841 125.332C284.68 127.736 285 129.393 285 130.333H295C295 127.695 294.235 124.767 293.282 122.036C292.297 119.212 290.954 116.174 289.489 113.185C286.556 107.202 282.968 101.087 280.28 96.7125L271.76 101.948ZM272.24 101.948C272.25 101.931 272.227 101.97 272.161 102.006C272.104 102.037 272.048 102.049 272 102.049C271.952 102.049 271.896 102.037 271.839 102.006C271.773 101.97 271.75 101.931 271.76 101.948L280.28 96.7125C276.459 90.4945 267.541 90.4945 263.72 96.7125L272.24 101.948Z",
    fill: "#808080",
    mask: "url(#path-11-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterbed);
export default __webpack_public_path__ + "static/media/waterbed.6c074767e1a7a2fe65c33057109a8063.svg";
export { ForwardRef as ReactComponent };